var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.product
    ? _c(
        "div",
        [
          _c("div", { staticClass: "row my-1 align-items-end" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "config-hidden",
                    rawName: "v-config-hidden",
                    value: _vm.makeConfig("product.itemNo"),
                    expression: "makeConfig('product.itemNo')"
                  }
                ],
                staticClass: "col-2"
              },
              [
                _c("label", { staticClass: "small fw-bold" }, [
                  _vm._v(_vm._s(_vm.$t("productQualityTests.edit.number")))
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: "disabled" },
                  domProps: { value: _vm.product.itemNo || "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "config-hidden",
                    rawName: "v-config-hidden",
                    value: _vm.makeConfig("product.group"),
                    expression: "makeConfig('product.group')"
                  }
                ],
                staticClass: "col-6"
              },
              [
                _c(
                  "label",
                  {
                    directives: [
                      {
                        name: "config-required",
                        rawName: "v-config-required",
                        value: _vm.makeConfig("product.group"),
                        expression: "makeConfig('product.group')"
                      }
                    ],
                    staticClass: "small fw-bold"
                  },
                  [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.name")))]
                ),
                _vm._v(" "),
                _c("vSelect", {
                  attrs: {
                    options: _vm.state.groupsStore.groupTypes,
                    label: "name",
                    reduce: group => group.id,
                    clearable: false,
                    disabled: !_vm.editable || _vm.product.id > 0
                  },
                  model: {
                    value: _vm.product.groupId,
                    callback: function($$v) {
                      _vm.$set(_vm.product, "groupId", $$v)
                    },
                    expression: "product.groupId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "config-hidden",
                    rawName: "v-config-hidden",
                    value: _vm.makeConfig("product.ident"),
                    expression: "makeConfig('product.ident')"
                  }
                ],
                staticClass: "col-4"
              },
              [
                _c(
                  "label",
                  {
                    directives: [
                      {
                        name: "config-required",
                        rawName: "v-config-required",
                        value: _vm.makeConfig("product.ident"),
                        expression: "makeConfig('product.ident')"
                      }
                    ],
                    staticClass: "small fw-bold"
                  },
                  [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.ident")))]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.ident,
                      expression: "product.ident"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.ident"),
                      expression: "makeConfig('product.ident')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.ident },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.product, "ident", $event.target.value)
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.name"),
                  expression: "makeConfig('product.name')"
                }
              ],
              staticClass: "row my-3"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.name"),
                      expression: "makeConfig('product.name')"
                    }
                  ],
                  staticClass: "col-2 d-flex align-items-center"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.title")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.name,
                      expression: "product.name"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.name"),
                      expression: "makeConfig('product.name')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.product, "name", $event.target.value)
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-hidden",
                      rawName: "v-config-hidden",
                      value: _vm.makeConfig("product.entryDate"),
                      expression: "makeConfig('product.entryDate')"
                    }
                  ],
                  staticClass: "row my-1"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "config-required",
                          rawName: "v-config-required",
                          value: _vm.makeConfig("product.entryDate"),
                          expression: "makeConfig('product.entryDate')"
                        }
                      ],
                      staticClass: "col-4 d-flex align-items-center"
                    },
                    [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.dateOut")))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8" }, [
                    _c(
                      "div",
                      { staticClass: "input-group" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("Datepicker", {
                          attrs: {
                            "monday-first": true,
                            language: _vm.datepickerDE,
                            "bootstrap-styling": true,
                            disabled: !_vm.editable
                          },
                          model: {
                            value: _vm.product.entryDate,
                            callback: function($$v) {
                              _vm.$set(_vm.product, "entryDate", $$v)
                            },
                            expression: "product.entryDate"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-hidden",
                      rawName: "v-config-hidden",
                      value: _vm.makeConfig("product.issueDate"),
                      expression: "makeConfig('product.issueDate')"
                    }
                  ],
                  staticClass: "row my-1"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "config-required",
                          rawName: "v-config-required",
                          value: _vm.makeConfig("product.issueDate"),
                          expression: "makeConfig('product.issueDate')"
                        }
                      ],
                      staticClass: "col-4 d-flex align-items-center"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("productQualityTests.edit.issueDate"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8" }, [
                    _c(
                      "div",
                      { staticClass: "input-group" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("Datepicker", {
                          attrs: {
                            "monday-first": true,
                            language: _vm.datepickerDE,
                            "bootstrap-styling": true,
                            disabled: !_vm.editable
                          },
                          model: {
                            value: _vm.product.issueDate,
                            callback: function($$v) {
                              _vm.$set(_vm.product, "issueDate", $$v)
                            },
                            expression: "product.issueDate"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-hidden",
                      rawName: "v-config-hidden",
                      value: _vm.makeConfig("product.status"),
                      expression: "makeConfig('product.status')"
                    }
                  ],
                  staticClass: "row my-1"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "config-required",
                          rawName: "v-config-required",
                          value: _vm.makeConfig("product.status"),
                          expression: "makeConfig('product.status')"
                        }
                      ],
                      staticClass: "col-3 d-flex align-items-center"
                    },
                    [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.status")))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.product.status,
                          expression: "product.status"
                        },
                        {
                          name: "config-required",
                          rawName: "v-config-required",
                          value: _vm.makeConfig("product.status"),
                          expression: "makeConfig('product.status')"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", disabled: !_vm.editable },
                      domProps: { value: _vm.product.status },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.product, "status", $event.target.value)
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-hidden",
                      rawName: "v-config-hidden",
                      value: _vm.makeConfig("product.responsible"),
                      expression: "makeConfig('product.responsible')"
                    }
                  ],
                  staticClass: "row my-1"
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "config-required",
                          rawName: "v-config-required",
                          value: _vm.makeConfig("product.responsible"),
                          expression: "makeConfig('product.responsible')"
                        }
                      ],
                      staticClass: "col-3 d-flex align-items-center"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("productQualityTests.edit.responsible")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.product.responsible,
                          expression: "product.responsible"
                        },
                        {
                          name: "config-required",
                          rawName: "v-config-required",
                          value: _vm.makeConfig("product.responsible"),
                          expression: "makeConfig('product.responsible')"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", disabled: !_vm.editable },
                      domProps: { value: _vm.product.responsible },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.product,
                            "responsible",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.warningMail"),
                  expression: "makeConfig('product.warningMail')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.warningMail"),
                      expression: "makeConfig('product.warningMail')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.warningmail")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.warningMail,
                      expression: "product.warningMail"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.warningMail"),
                      expression: "makeConfig('product.warningMail')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.warningMail },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.product, "warningMail", $event.target.value)
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.testSpecification"),
                  expression: "makeConfig('product.testSpecification')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.testSpecification"),
                      expression: "makeConfig('product.testSpecification')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.testarea")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.testSpecification,
                      expression: "product.testSpecification"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.testSpecification"),
                      expression: "makeConfig('product.testSpecification')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.testSpecification },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.product,
                        "testSpecification",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.errorMargin"),
                  expression: "makeConfig('product.errorMargin')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.errorMargin"),
                      expression: "makeConfig('product.errorMargin')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.tolerance")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.errorMargin,
                      expression: "product.errorMargin"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.errorMargin"),
                      expression: "makeConfig('product.errorMargin')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.errorMargin },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.product, "errorMargin", $event.target.value)
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.testProcedure"),
                  expression: "makeConfig('product.testProcedure')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.testProcedure"),
                      expression: "makeConfig('product.testProcedure')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.testMethod")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.testProcedure,
                      expression: "product.testProcedure"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.testProcedure"),
                      expression: "makeConfig('product.testProcedure')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.testProcedure },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.product,
                        "testProcedure",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.costCenter"),
                  expression: "makeConfig('product.costCenter')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.costCenter"),
                      expression: "makeConfig('product.costCenter')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.costCenter")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.costCenter,
                      expression: "product.costCenter"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.costCenter"),
                      expression: "makeConfig('product.costCenter')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.costCenter },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.product, "costCenter", $event.target.value)
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.note"),
                  expression: "makeConfig('product.note')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.note"),
                      expression: "makeConfig('product.note')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.comment")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.note,
                      expression: "product.note"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.note"),
                      expression: "makeConfig('product.note')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { rows: "2", disabled: !_vm.editable },
                  domProps: { value: _vm.product.note },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.product, "note", $event.target.value)
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.revision"),
                  expression: "makeConfig('product.revision')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.revision"),
                      expression: "makeConfig('product.revision')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [_vm._v(_vm._s(_vm.$t("productQualityTests.edit.revision")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.revision,
                      expression: "product.revision"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.revision"),
                      expression: "makeConfig('product.revision')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.revision },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.product, "revision", $event.target.value)
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.disabled"),
                  expression: "makeConfig('product.disabled')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c("div", { staticClass: "col-2" }, [
                _c(
                  "label",
                  {
                    staticClass: "form-check-label",
                    attrs: { for: _vm.uid + "enabled" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("productQualityTests.edit.enabled")) + " "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.productEnabled,
                        expression: "productEnabled"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      disabled: !_vm.editable,
                      id: _vm.uid + "enabled"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.productEnabled)
                        ? _vm._i(_vm.productEnabled, null) > -1
                        : _vm.productEnabled
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.productEnabled,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.productEnabled = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.productEnabled = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.productEnabled = $$c
                        }
                      }
                    }
                  })
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.customString1"),
                  expression: "makeConfig('product.customString1')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.customString1"),
                      expression: "makeConfig('product.customString1')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("productQualityTests.edit.customString1"))
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.customString1,
                      expression: "product.customString1"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.customString1"),
                      expression: "makeConfig('product.customString1')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.customString1 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.product,
                        "customString1",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.customString2"),
                  expression: "makeConfig('product.customString2')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.customString2"),
                      expression: "makeConfig('product.customString2')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("productQualityTests.edit.customString2"))
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.customString2,
                      expression: "product.customString2"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.customString2"),
                      expression: "makeConfig('product.customString2')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.customString2 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.product,
                        "customString2",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "config-hidden",
                  rawName: "v-config-hidden",
                  value: _vm.makeConfig("product.customString3"),
                  expression: "makeConfig('product.customString3')"
                }
              ],
              staticClass: "row my-1"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.customString3"),
                      expression: "makeConfig('product.customString3')"
                    }
                  ],
                  staticClass: "col-2"
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("productQualityTests.edit.customString3"))
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-10" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.customString3,
                      expression: "product.customString3"
                    },
                    {
                      name: "config-required",
                      rawName: "v-config-required",
                      value: _vm.makeConfig("product.customString3"),
                      expression: "makeConfig('product.customString3')"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", disabled: !_vm.editable },
                  domProps: { value: _vm.product.customString3 },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.product,
                        "customString3",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showArchiveFields
            ? [
                _c("div", { staticClass: "row my-1 bg-light p-2 rounded" }, [
                  _c("div", { staticClass: "col-2 fw-bold" }, [
                    _vm._v("Grund")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4" }, [
                    _vm._v(_vm._s(_vm.product.archiveReason))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2 fw-bold" }, [
                    _vm._v("Risiko")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4" }, [
                    _vm._v(_vm._s(_vm.archiveRisk))
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row my-2" }, [
            _c("div", { staticClass: "col small text-muted" }, [
              _vm._v(_vm._s(_vm.$t("productQualityTests.edit.mandatory")))
            ])
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("PqtMeasurementSpecifications", {
            attrs: { container: _vm.product, editable: _vm.editable }
          }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("ImageViewer", {
            attrs: {
              isShowDelete: _vm.allowMediaDelete,
              medias: _vm.product.files
            },
            on: {
              "removed-media": function($event) {
                return _vm.removeMedia($event)
              }
            }
          }),
          _vm._v(" "),
          _c("DropZone", {
            staticClass: "mt-2",
            attrs: { formId: "dz_product" + _vm._uid },
            on: { uploaded: _vm.fileUploaded }
          }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-2"
            },
            [
              _c("h5", { staticClass: "mb-0" }, [_vm._v("Tests")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.exportCSV }
                },
                [
                  _c("i", { staticClass: "fa fa-download" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("productQualityTests.edit.export")) +
                      "\n    "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("VueGoodTable", {
            ref: "table",
            attrs: {
              columns: _vm.testColumns,
              rows: _vm.tests || [],
              isLoading: _vm.tests === null,
              "pagination-options": _vm.paginationOptions,
              "select-options": _vm.selectConfig,
              "search-options": _vm.searchOptions
            },
            on: { "on-row-click": _vm.onClick },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-row",
                  fn: function(props) {
                    return [
                      props.column.field === "actions"
                        ? _c("div", { staticClass: "btn-group" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.exportTest(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-file-excel" })]
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(props.formattedRow[props.column.field])
                            )
                          ])
                    ]
                  }
                }
              ],
              null,
              false,
              3663583003
            )
          }),
          _vm._v(" "),
          _c("PqtProductTestEditModal", {
            ref: "testModal",
            on: {
              "file-added": function($event) {
                return _vm.$emit("test-file-added", $event)
              }
            }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fa fa-calendar" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fa fa-calendar" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }